import { checkCreditAuthorization } from './client';
import { useEffect, useState } from 'react';
import { useCredits } from './CreditsProvider';
import Raven from 'raven-js';
export function useCreditCheck({
  action,
  numberOfOperations
}) {
  const {
    creditsPolicy,
    isIncludedEnrichment,
    isHubspotCredits
  } = useCredits();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasUserLoaded = creditsPolicy.user.isLoaded;
  const shouldSkipCreditCheck = !isHubspotCredits || isIncludedEnrichment && action === 'DATASET_ENRICHMENT';
  const operations = numberOfOperations || 0;
  useEffect(() => {
    if (!hasUserLoaded) {
      return;
    }

    /**
     * @todo Remove hasHubspotCredits credit check
     * once HubSpotCredits is fully ungated
     */
    if (shouldSkipCreditCheck) {
      setIsAuthorized(true);
      setIsLoading(false);
      return;
    }
    if (operations < 0) {
      setIsAuthorized(false);
      setIsLoading(false);
      return;
    }
    setError(null);
    checkCreditAuthorization({
      action,
      numberOfOperations: operations
    }).then(({
      authorized
    }) => {
      setIsAuthorized(authorized);
    }).catch(err => {
      setError(err instanceof Error ? err : new Error('Failed to check credit authorization'));
      Raven.captureException(err, {
        extra: {
          action,
          numberOfOperations: operations
        }
      });
      setIsAuthorized(false);
    }).finally(() => {
      setIsLoading(false);
    });
  }, [action, hasUserLoaded, isHubspotCredits, isIncludedEnrichment, operations, shouldSkipCreditCheck]);
  return {
    isAuthorized,
    hasError: !!error,
    isLoading
  };
}